import { defineStore } from 'pinia';
import { useSessionStore } from './session';
import Dinero from 'dinero.js';
import { configure as gtagConfigure, event as gtagEvent } from 'vue-gtag';

export const useAnalyticsStore = defineStore('analytics', () => {
    console.log('📊 analytics store loaded');

    // Add google tag script to head
    function addGoogleTagManager(measurementId) {
        // skip loading script if GTM_PARAMS not found
        if (!measurementId) {
            console.log('ℹ️ unable to load Google Tag Manager without measurement ID');
            return;
        }

        console.info(`configure ga: ${measurementId}`);

        gtagConfigure({
            tagId: measurementId,
        });

        console.info(`end configure ga: ${measurementId}`);
    }

    const session = useSessionStore();

    function event(eventName, eventParams = {}) {
        console.info(`event firing: ${eventName}`, eventParams);

        gtagEvent(eventName, eventParams);

        console.info(`event fired: ${eventName}`, eventParams);
    }

    const sessionInitialized = computed(() => {
        return session.initialized;
    });

    const space = computed(() => {
        return session.getSpace;
    });

    const amount = computed(() => {
        return session.getItemsTotalAmount;
    });

    // Watch for space changes
    watch(space, (value) => {
        if (value && sessionInitialized.value) {
            submitSpace(value);
        }
    });

    function phoneClicked() {
        event('phone_clicked');
    }

    function bookStart() {
        event('book_start');
    }

    function bookLead() {
        event('book_lead', {
            value: space.value,
        });
    }

    function bookLeadWithEnergy() {
        event('book_lead_with_energy', {
            value: space.value,
        });
    }

    function bookConfirmed() {
        event('book_confirmed', {
            value: amount?.value ? Dinero({ amount: amount.value }).toFormat('0.00') : 0.0,
            currency: 'AUD',
        });
    }

    function bookConfirmedWithEnergy() {
        event('book_confirmed_with_energy', {
            value: amount?.value ? Dinero({ amount: amount.value }).toFormat('0.00') : 0.0,
            currency: 'AUD',
        });
    }

    function stepInventory() {
        event('step_inventory', {
            value: space.value,
        });
    }

    function chatStarted() {
        event('chat_started');
    }

    function paymentIntent() {
        event('payment_intent', {
            value: amount?.value ? Dinero({ amount: amount.value }).toFormat('0.00') : 0.0,
            currency: 'AUD',
        });
    }

    function submitSpace() {
        event('submit_space', {
            value: space.value,
        });
    }

    function addressSearch(count) {
        event('address_search', {
            count: count,
        });
    }

    return {
        addGoogleTagManager,

        // comm triggers
        phoneClicked,
        chatStarted,

        bookStart,
        bookLead,
        bookLeadWithEnergy,
        bookConfirmed,
        bookConfirmedWithEnergy,

        submitSpace,
        stepInventory,
        paymentIntent,

        addressSearch,
    };
});
